import { render, staticRenderFns } from "./manpower_bar.vue?vue&type=template&id=820c2746&"
import script from "./manpower_bar.vue?vue&type=script&lang=js&"
export * from "./manpower_bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports